(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('uploadedModelsService', uploadedModelsService);

    uploadedModelsService.$inject = ['$http', '$q', '$log'];

    function uploadedModelsService($http, $q, $log) {
        var baseUrl = '/uploaded-models/';

        return {
            registerModel: registerModel,
            getModelsByCurrentUser: getModelsByCurrentUser,
            removeModel: removeModel
        };

        function registerModel(modelID) {
            var requestUrl = baseUrl + modelID + '/register';
            return $http.post(requestUrl);
        }

        function getModelsByCurrentUser(pageNumber, pageSize, sortEntries, filterEntries, canceler) {
            var loadRequest = {
                PageNumber: pageNumber,
                PageSize: pageSize,
                SortEntries: sortEntries || getDefaultSorting(),
                FilterEntries: filterEntries
            };

            return $http.post(baseUrl + "get-for-current-user", loadRequest, { canceler: canceler })
                .then(function (response) {
                    return response.data;
                });
        }

        function removeModel(modelID) {
            var requestUrl = baseUrl + modelID + '/delete';
            return $http.post(requestUrl);
        }

        // -----------------------------------------------------------------------------------------

        function getDefaultSorting() {
            return [
                { propertyName: 'UploadDate', direction: 2 }
            ];
        }
    }
}());